import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthenticationService } from '@flexyoo/auth';
import { BehaviorSubject } from 'rxjs';
import { MatCard } from '@angular/material/card';
import { GenericPageWithLogoComponent } from '@flexyoo/shared/ui';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatError, MatFormField, MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { emailValidator } from '../../../shared/validators/email.validator';

type IFormValue = {
  email: FormControl<string>;
};
@Component({
  selector: 'app-reset-password',
  templateUrl: 'reset-password.component.html',
  styleUrls: ['reset-password.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatCard,
    GenericPageWithLogoComponent,
    AsyncPipe,
    ReactiveFormsModule,
    TranslateModule,
    MatFormField,
    MatError,
    MatInput,
    MatButton,
    RouterLink,
  ],
})
export class ResetPasswordComponent {
  public readonly showMailResponse$ = new BehaviorSubject<boolean>(false);
  public readonly form = new FormGroup<IFormValue>({
    email: new FormControl('', [Validators.required, emailValidator]),
  });

  constructor(private readonly auth: AuthenticationService) {}

  public submit(): void {
    if (!this.form.valid) {
      return;
    }

    this.auth
      .requestPasswordReset(this.form.value.email)
      .subscribe(() => this.showMailResponse$.next(true));
  }
}
